/**
 * Redemption ladder + sign-in strip.
 */
import { Sparkles } from "lucide-react";

const REDEMPTIONS = [
    { pts: 100, off: 5 },
    { pts: 200, off: 10 },
    { pts: 500, off: 25 },
    { pts: 800, off: 40 },
    { pts: 1000, off: 60 },
    { pts: 1500, off: 100 },
    { pts: 2000, off: 150 },
    { pts: 3000, off: 250, best: true },
];

export default function LoyaltyRedemption({ onOpenModal }) {
    return (
        <>
            <section data-testid="loyalty-redemption" className="bg-zen-bg">
                <div className="max-w-[1200px] mx-auto px-6 sm:px-10 py-12">
                    <div className="mb-6">
                        <p className="text-[11px] uppercase tracking-[0.3em] text-zen-olive mb-4">
                            Redeem your points
                        </p>
                        <h2 className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl text-zen-ink leading-tight tracking-tight max-w-2xl">
                            Eight ways to cash in.
                        </h2>
                        <p className="text-sm sm:text-base text-zen-ink-soft mt-5 max-w-2xl leading-relaxed">
                            Use points at checkout — in-store, online, or on delivery.
                            The higher you stack, the better the rate gets.
                        </p>
                    </div>
                    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2 sm:gap-3">
                        {REDEMPTIONS.map((r) => (
                            <div
                                key={r.pts}
                                data-testid={`loyalty-redeem-${r.pts}`}
                                className={`relative p-4 border bg-zen-surface flex flex-col items-center text-center ${
                                    r.best
                                        ? "border-zen-olive bg-zen-olive/5"
                                        : "border-zen-line"
                                }`}
                            >
                                {r.best && (
                                    <p className="absolute -top-2 left-1/2 -translate-x-1/2 bg-zen-olive text-zen-bg text-[9px] uppercase tracking-[0.18em] px-2 py-0.5">
                                        Best value
                                    </p>
                                )}
                                <p className="text-[10px] uppercase tracking-[0.22em] text-zen-ink-soft mb-2 mt-1">
                                    {r.pts.toLocaleString()} pts
                                </p>
                                <p className="font-serif text-3xl text-zen-ink font-light leading-none">
                                    ${r.off}
                                </p>
                                <p className="text-[10px] uppercase tracking-[0.22em] text-zen-ink-soft mt-2">
                                    off
                                </p>
                            </div>
                        ))}
                    </div>
                    <p className="text-xs text-zen-ink-soft mt-8 max-w-2xl leading-relaxed">
                        Points stay live as long as you shop at least once every 180
                        days — every purchase resets the clock on every point you have.
                    </p>
                </div>
            </section>

            <section
                data-testid="loyalty-signin-strip"
                className="bg-zen-elevated text-zen-cream"
            >
                <div className="max-w-[1100px] mx-auto px-6 sm:px-10 py-12 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
                    <div className="lg:col-span-7">
                        <p className="text-[11px] uppercase tracking-[0.3em] opacity-70 mb-4">
                            Already a member?
                        </p>
                        <h2 className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight mb-5">
                            Sign in. Check your balance.
                        </h2>
                        <p className="text-sm sm:text-base opacity-80 max-w-xl leading-relaxed">
                            Drop in the phone number on your account. We&rsquo;ll text
                            you a 6-digit code, verify it&rsquo;s you, and show your
                            points, your tier, and your next reward.
                        </p>
                    </div>
                    <div className="lg:col-span-5">
                        <button
                            onClick={onOpenModal}
                            data-testid="loyalty-open-modal-secondary"
                            className="w-full bg-zen-cream text-zen-ink px-7 py-4 text-[11px] uppercase tracking-[0.22em] font-medium hover:bg-zen-bg transition-colors inline-flex items-center justify-center gap-2"
                        >
                            <Sparkles size={13} /> Text me a code
                        </button>
                        <p className="text-[10px] uppercase tracking-[0.22em] opacity-60 mt-3 text-center">
                            One-time SMS · msg & data rates may apply
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
}
